import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthService } from '@core';

@Component({
  selector: 'app-user-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule, TranslocoPipe],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      [attr.aria-label]="'userMenu.label' | transloco"
      data-testid="main-user-menu-trigger"
    >
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item (click)="navigateToProfile()" data-testid="main-user-menu-profile">
        <mat-icon>person</mat-icon>
        <span>{{ 'userMenu.profile' | transloco }}</span>
      </button>
      <button mat-menu-item (click)="navigateToHousehold()" data-testid="main-user-menu-household">
        <mat-icon>groups</mat-icon>
        <span>{{ 'userMenu.household' | transloco }}</span>
      </button>
      <button mat-menu-item (click)="navigateToSettings()" data-testid="main-user-menu-settings">
        <mat-icon>settings</mat-icon>
        <span>{{ 'userMenu.settings' | transloco }}</span>
      </button>
      <button mat-menu-item (click)="navigateToPrivacy()" data-testid="main-user-menu-privacy">
        <mat-icon>shield</mat-icon>
        <span>{{ 'userMenu.privacy' | transloco }}</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()" data-testid="main-user-menu-logout">
        <mat-icon>logout</mat-icon>
        <span>{{ 'userMenu.logout' | transloco }}</span>
      </button>
    </mat-menu>
  `,
})
export class UserMenuComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  navigateToProfile() {
    this.router.navigateByUrl('/profile');
  }

  navigateToHousehold() {
    this.router.navigateByUrl('/household');
  }

  navigateToSettings() {
    this.router.navigateByUrl('/settings');
  }

  navigateToPrivacy() {
    this.router.navigateByUrl('/profile/privacy');
  }

  logout() {
    const session = this.auth.getSession();
    this.auth.logout(session).subscribe({
      next: () => this.router.navigateByUrl('/auth/login'),
      error: () => this.router.navigateByUrl('/auth/login'),
    });
  }
}
